import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './styles/fonts.css'
// Theme layer FIRST so the cascade is resolved before theme.ts reads CSS vars.
import './styles/solvigo-tokens.css'
import './styles/theme-solvigo.css'
import './styles/theme-minprilla.css'
import './index.css'
// Selects the tenant overlay from config (before theme.ts reads CSS vars).
import './applyTheme'
import App from './App.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
